import { Fragment, useState, useContext } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Countdown from "react-countdown";
import { Login } from "../../components/backgrounds/Login";
import { Otp, digitosFirma } from "../../components/legal/Otp";
import { HttpRequest } from "../../services/httpRequest";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { ProgressLinear } from "../../components/progress/progressLinear";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Primary } from "../../components/buttons/Primary";
import { variablesGlobales } from "../../configs/variables";

export function VerificationPhonePage() {
  const { token } = useContext(AuthContext);

  const navigate = useNavigate();
  const { state } = useLocation();
  const phone = state?.phone || localStorage.getItem("phone") || "3002009876";
  const emailUser = state?.email || "";
  const doc = state?.doc || "";
  const celularProtect = "********" + phone.substring(8);

  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState();
  const [isOpenError, setIsOpenError] = useState();
  const [viewalert, setViewalert] = useState(false);
  const [viewProgress, setViewProgress] = useState(false);
  const [showCountDown, setShowCountDown] = useState(false);

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(true);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(true);
    }
  };

  const handleProgress = (isView) => {
    setViewProgress(isView);
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const reeenviarToken = async (e) => {
    e.preventDefault();

    if (showCountDown === true) {
      setShowCountDown(false);
    }

    let payload = Object.assign({}, { doc: doc });

    handleOpenAlert("success", `Token enviado exitosamente!`, true);

    try {
      const responseService = await HttpRequest.loginRequestSms(payload);
      setShowCountDown(true);
      if (responseService.error) {
        if (responseService.message.code === "NOTEXISTUSER") {
          handleOpenAlert(
            "error",
            "Ups! El usuario no existe con el documento ingresado.",
            true
          );
          return setTimeout(() => {
            navigate("/registrarse");
          }, 2000);
        } else if (responseService.message.code === "ACCOUNTBLOCK") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true
          );
          return;
        } else if (responseService.message.code === "INVALIDCREDENTIALS") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true
          );
          return;
        }

        handleOpenAlert(
          "error",
          "Ups! Error interno, intenta nuevamente",
          true
        );
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (event) => {
    try {
      handleClearStateAlert();

      event.preventDefault();

      handleProgress(true);

      let payload = Object.assign({}, { doc: doc, otp: token });

      const responseService = await HttpRequest.validateTokenSessionVisitor(payload);

      if (responseService.error) {
        if (responseService.message.code === "NOTEXISTUSER") {
          handleOpenAlert("error", responseService.message, true);
          handleProgress(false);
          return;
        } else if (responseService.message.code === "ACCOUNTBLOCK") {
          handleOpenAlert("error", responseService.message, true);
          handleProgress(false);
          return;
        } else if (responseService.message.code === "INVALIDTOKEN") {
          handleOpenAlert("error", responseService.message?.message, true);
          handleProgress(false);
          return;
        }

        handleOpenAlert("error", "Ups! Error interno, intente más tarde", true);
        handleProgress(false);
        return;
      }

      setTimeout(() => {
        localStorage.setItem("doc", doc);
        localStorage.setItem("is_signin", true);
        localStorage.setItem("token", responseService.message.otp);
       //localStorage.setItem("token_jwt", responseService.message.tokenJwt);
        localStorage.setItem("type_user", variablesGlobales.typeUserVisitor);
        handleProgress(false);
        return navigate("/formulariouno", { replace: true, state: {} });
      }, 3000);
    } catch (error) {
      console.log(error);
      handleProgress(false);
      return navigate("/");
    }
  };

  const BtnReenviarToken = () => {
    return (
      <div className="items-center pb-10">
        <div className="block text-center">
          <Link to="/" onClick={reeenviarToken}>
            <a className="text-purple underline">Reenviar código</a>
          </Link>
        </div>
      </div>
    )
  }

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return <BtnReenviarToken />;
    } else {
      // Render a countdown
      return (
        <span>
          {hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  return (
    <Fragment>
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}
      <Login
        classVeri="mt-16"
        title="Verificación de seguridad"
        description={`Digita el código de ${digitosFirma} dígitos que hemos enviado a tu celular ${celularProtect}.`}
        form={
          <form
            action="#"
            method="POST"
            className="space-y-6 h-96"
            onSubmit={handleSubmit}
          >
            <div className="text-center block">
              <Otp name="tokensms" id="tokensms" />
            </div>
            <div className="pt-8">
              <div>
                {viewProgress ? (
                  <Fragment>
                    <ProgressLinear></ProgressLinear>
                    <p>Estamos verificando el código, por favor espera...</p>
                  </Fragment>
                ) : (
                  <Primary onSubmit={handleSubmit} text={"Verificar código"} />
                )}
              </div>
            </div>
            {/*  Se agrega countdown para reenvío de mensajes  */}

            {
              showCountDown === true ?
                <div className="items-center pb-10">
                  <div className="block text-center countdown-reenviartoken">
                    <Countdown date={Date.now() + 60000} renderer={renderer} />
                  </div>
                </div>
                :
                <div className="items-center pb-10">
                  <div className="block text-center">
                    <Link to="/" onClick={reeenviarToken}>
                      <a className="text-purple underline">Reenviar código</a>
                    </Link>
                  </div>
                </div>
            }
          </form>
        }
        message={
          <span className="flex justify-center pt-10 mx-auto text-lg">
            ¿No tienes acceso a tu celular?{" "}
            <Link
              to="/autenticarse-email"
              state={{ email: emailUser, doc: doc, isSendToken: true }}
            >
              <a
                href="/autenticarse-email"
                className="text-purple pl-2 underline"
              >
                {" "}
                Intenta con tu correo.{" "}
              </a>
            </Link>
          </span>
        }
      />
    </Fragment>
  );
}
